<template>
  <div>
    <EditcourseComponent />
  </div>
</template>

<script>
import EditcourseComponent from "../../components/Courses/editcourse.component.vue";
export default {
  components: { EditcourseComponent },
};
</script>
